<section class="clientMarkup" [class.clientMarkupFull]="isTableLayout">
  <div class="clientMarkupTemplates" *ngIf="isTableLayout">
    <div class="clientMarkupTemplatesText">
      <h3>Шаблон от глобальной таблицы</h3>
      <p>Система создаст клиентские правила из глобальных и сохранит ручные исключения по папкам и брендам.</p>
    </div>

    <div class="clientMarkupTemplatesActions">
      <button
        mat-stroked-button
        color="primary"
        type="button"
        *ngFor="let option of templateOptions"
        (click)="applyTemplate(option.delta)"
        [disabled]="loading || applyingTemplate"
      >
        <mat-icon *ngIf="!applyingTemplate">auto_fix_high</mat-icon>
        <mat-icon *ngIf="applyingTemplate"><mat-spinner [diameter]="18"></mat-spinner></mat-icon>
        {{ option.label }}
      </button>

      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="applyHistoryTemplate()"
        [disabled]="loading || applyingTemplate"
      >
        <mat-icon *ngIf="!applyingTemplate">history</mat-icon>
        <mat-icon *ngIf="applyingTemplate"><mat-spinner [diameter]="18"></mat-spinner></mat-icon>
        История 12м
      </button>
    </div>
  </div>

  <div class="loadError" *ngIf="error" role="alert"><span>{{ error }}</span><button mat-stroked-button (click)="load()">Повторить</button></div>
  <app-markup-rules-table
    mode="client"
    [rules]="dataSource"
    [loading]="loading || applyingTemplate"
    [readonly]="false"
    [allowRecalculate]="false"
    [layout]="layout"
    (createRule)="add()"
    (editRule)="update($event)"
    (deleteRule)="remove($event)"
    (refreshRules)="load()"
  ></app-markup-rules-table>
</section>
